import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {MuleService} from "../../models/mule-service";

@Injectable()
export class MuleControllerService {

  private muleUrl: string = environment.BASE_URL + "mule/services";

  constructor(private http: HttpClient) {
  }

  public getServicesList(): Observable<MuleService[]> {
    return this.http.get(this.muleUrl + "?withoutdata=true&dbOrder=code,-version") as  Observable<MuleService[]> ;
  }

  public getService(serviceId: string): Observable<MuleService> {
    return this.http.get(this.muleUrl + "/" + serviceId) as  Observable<MuleService> ;
  }

}
